import React from 'react'
import Footer from '../../components/Footer'
import HomeHeader from '../../components/HomeHeader'
import Sidebar from '../../components/SideBar'
import SubscriptionsListComponent from './components/SubscriptionsListComponent'

const SubscriptionList: React.FC = () => {
  return (
    <>
      <Sidebar />
      <HomeHeader />
      <SubscriptionsListComponent />
      <Footer />
    </>
  )
}

export default SubscriptionList
